module.exports = __webpack_public_path__ + "img/banner.98d75c33.png";